"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _styledButtons = require("./styled-buttons");
var _excluded = ["showButton"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  showButton: false
};
var propTypes = {
  showButton: _propTypes["default"].bool
};
function NextButton(_ref) {
  var showButton = _ref.showButton,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledButtons.StyledNextButton, {
    className: !showButton && 'hidden'
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "6.1rem",
    height: "100%",
    viewBox: "0 0 61 44",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "url(#paint0_linear_next)",
    y: "0",
    height: "100%",
    x: "0",
    width: "100%"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint0_linear_next",
    gradientUnits: "userSpaceOnUse",
    x1: "0%",
    x2: "80%",
    y1: "0",
    y2: "0"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0",
    stopColor: "var(--color-global-grey100)",
    stopOpacity: "0"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.9",
    stopColor: "var(--color-global-grey200)",
    stopOpacity: "1"
  }))), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "100%",
    y1: "10",
    x2: "100%",
    y2: "34",
    stroke: "var(--color-global-grey400)",
    strokeWidth: "1px"
  })), /*#__PURE__*/_react["default"].createElement(_styledButtons.StyledButtonContainer, {
    className: "fuse-tabs__next-button-icon-container",
    "data-testid": "fuse-tabs-next-button-icon-container-test-id"
  }, /*#__PURE__*/_react["default"].createElement(_buttons.PlainIconButton, _extends({
    className: "fuse-tabs__next-button-icon",
    "data-testid": "fuse-tabs-next-button-icon-test-id",
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    size: "medium",
    srLabel: "Show next tabs"
  }, props))));
}
NextButton.propTypes = propTypes;
NextButton.defaultProps = defaultProps;
var _default = exports["default"] = NextButton;